import { render, staticRenderFns } from "./SftpIcon.vue?vue&type=template&id=56d33158"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-intelligent-match/mfe-intelligent-match/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d33158')) {
      api.createRecord('56d33158', component.options)
    } else {
      api.reload('56d33158', component.options)
    }
    module.hot.accept("./SftpIcon.vue?vue&type=template&id=56d33158", function () {
      api.rerender('56d33158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SftpIcon.vue"
export default component.exports